import { AppState } from "./type";

export const INITIAL_APP_STATE: AppState = {
  bootstrap: {
    data: {
      _id: "",
      name: "",
      desc: "",
      darkLogo: "",
      lightLogo: "",
      favicon: "",
      headText: "",
      config: {},
      domain: "",
      status: "inactive",
    },
    type: "template",
    sidebars: [],
    banners: {},
    footer: {
      lists: [],
      items: [],
      images: [],
    },
    faqs: [],
    languages: [],
  },
};
